import signedFetch from '../util/unsignedFetch.js';

export default (token, body) => {
  const url = `${__API_BASE__}/open/decline-invite/${token}`;
  return signedFetch('PUTDeclineOrgInviteUpdate', url, 'PUT', body);
};
